import React from 'react'

function DivButtonUA(props) {
    const onKeyPress = (e) => {
        if (e.target.id === props.id) {
            if ((e.key === ' ') || (e.key === 'Enter'))  props.onClick(e)
        } 
    }

    return (
        <React.Fragment>
            <div
                id={props.id}
                className={!props.disabled ? props.className : `${props.className} disabled-divbutton`}
                role={!props.disabled ? 'button' : null}
                onClick={!props.disabled ? props.onClick : null}
                disabled={props.disabled}
                onKeyPress={props.onClick ? onKeyPress : null}
                tabIndex={!props.disabled ? 0 : null}>
                {props.children}
            </div>
            <style jsx='true'>
            {`
                .disabled-divbutton { opacity: 0.7; }
            `}
            </style>
        </React.Fragment>
    )

}

export default React.memo(DivButtonUA)